import React from 'react';
import { bool, shape, string } from 'prop-types';

const DraftColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696F88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.16634 1.16675H3.49967C2.85801 1.16675 2.33884 1.69175 2.33884 2.33341L2.33301 11.6667C2.33301 12.3084 2.85217 12.8334 3.49384 12.8334H10.4997C11.1413 12.8334 11.6663 12.3084 11.6663 11.6667V4.66675L8.16634 1.16675ZM3.49967 11.6667V2.33341H7.58301V5.25008H10.4997V11.6667H3.49967Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
  </svg>
);

DraftColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default DraftColor;
